//import React from "react";
import React, { useState, useEffect, useRef } from "react";
import { NavLink, Link } from "react-router-dom";
import logo from "../../img/logo.png";
import teacher_with_students from "../../img/teacher_with_students_two.jpg";
import megaphone from "../../img/megaphone_two.jpg";
import gears from "../../img/cartoon-gears.jpg";
import left from "../../img/left-arrow.jpg";
import head from "../../img/head-cartoon.jpg";
import house from "../../img/house-cartoon.jpg";
import right from "../../img/right-arrow.jpg";
import comp_screen from "../../img/computer-screen.jpg";
import example_questions from "../../img/example-questions.jpg";
import bullet_one from "../../img/bullet-one.jpg";
import bullet_two from "../../img/bullet-two.jpg";
import bullet_three from "../../img/bullet-three.jpg";
import bullet_four from "../../img/bullet-four.jpg";
import bullet_five from "../../img/bullet-five.jpg";
import bullet_six from "../../img/bullet-six.jpg";
import bullet_seven from "../../img/bullet-seven.jpg";
import bullet_eight from "../../img/bullet-eight.jpg";
import bullet_nine from "../../img/bullet-nine.jpg";
import bullet_fivedotfive from "../../img/bullet-fivedotfive.jpg";
import cartoon_computer from "../../img/cartoon-computer.jpg";
import hands from "../../img/hands.jpg";
import factors_diagram from "../../img/circle-graphic.png";
import teacher_paperwork from "../../img/teacher_paperwork.jpg";
import quote_open from "../../img/quote_open.jpg";
import quote_close from "../../img/quote_close.jpg";
import students_studying from "../../img/students-studying.jpg";
import cei_graphic from "../../img/cei-graphic.png";
import cei_graphic_green from "../../img/cei-graphic-green.png";
import mason_photo from "../../img/mason-photo.png";
import mason_signature from "../../img/mason-signature.png";
import sponsor_one from "../../img/sponsor-one.png";
import sponsor_two from "../../img/sponsor-two.png";
import sponsor_three from "../../img/sponsor-three.png";
import sponsor_four from "../../img/sponsor-four.png";
import sponsor_five from "../../img/sponsor-five.png";
import sponsor_six from "../../img/sponsor-six.png";
import sponsor_seven from "../../img/sponsor-seven.png";
import sponsor_eight from "../../img/learning-forward-logo.png"
import taking_survey from "../../img/taking-survey.png";
import sampleQuestions from "../../img/sample-questions.jpg";
import purpose from "../../img/purpose.jpg";
import data from "../../img/data.jpg";
import { Button, Menu, MenuItem } from "@mui/material";
import manual from "../../pdf/manual.pdf";

export default function Welcome(props) {
  // If the screen is taller than wide, show mobile view
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  const mobileView = screenHeight > screenWidth || screenWidth < 768;

  const [hoveredBar, setHoveredBar] = useState(null);

  // Scroll fade-in animation
  const fadeRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    fadeRefs.current.forEach(ref => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  const addToFadeRefs = (el) => {
    if (el && !fadeRefs.current.includes(el)) {
      fadeRefs.current.push(el);
    }
  };

  // Sample data
  const chartData = [
    {
      id: 1,
      label: "1. Leadership & A Compassionate School Community",
      junebug: 2.8,
      national: 3.0,
    },
    {
      id: 2,
      label: "2. Conscious Awareness of Emotions and Stress",
      junebug: 2.0,
      national: 2.5,
    },
    { id: 3, label: "3. Confidence & Positivity", junebug: 2.5, national: 2.7 },
    { id: 4, label: "4. Courage & Resiliency", junebug: 3.2, national: 3.1 },
    { id: 5, label: "5. Culture of Belonging", junebug: 2.6, national: 2.8 },
  ];

  const maxValue = 4;
  const barHeight = mobileView ? 14 : 18;
  const barSpacing = mobileView ? 50 : 60;
  const chartLeftMargin = mobileView ? 20 : 450;
  const chartWidth = mobileView ? Math.min(screenWidth - 80, 300) : 500;

  // Render chart function
  const renderFactorChart = () => {
    // For mobile, we need a different layout with labels above bars
    if (mobileView) {
      return (
        <div
          style={{
            padding: "20px 10px",
            backgroundColor: "transparent",
            fontFamily: "Arial, sans-serif",
          }}
        >
          {/* Title */}
          <h2
            style={{
              textAlign: "center",
              fontSize: "22px",
              marginBottom: "15px",
              fontWeight: "400",
            }}
          >
            Factor Averages
          </h2>

          {/* Legend */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "20px",
              marginBottom: "20px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <div
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: "#7BC96F",
                }}
              ></div>
              <span style={{ fontSize: "12px" }}>Junebug</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <div
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: "#999999",
                }}
              ></div>
              <span style={{ fontSize: "12px" }}>National</span>
            </div>
          </div>

          {/* Mobile-friendly chart with stacked labels */}
          {chartData.map((item, index) => (
            <div key={item.id} style={{ marginBottom: "20px" }}>
              <div style={{ fontSize: "12px", marginBottom: "5px", color: "#333" }}>
                {item.label}
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "5px", marginBottom: "3px" }}>
                <div
                  style={{
                    width: `${(item.junebug / maxValue) * 100}%`,
                    height: "16px",
                    backgroundColor: "#7BC96F",
                    borderRadius: "4px",
                  }}
                ></div>
                <span style={{ fontSize: "11px", color: "#666" }}>{item.junebug}</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                <div
                  style={{
                    width: `${(item.national / maxValue) * 100}%`,
                    height: "16px",
                    backgroundColor: "#999999",
                    borderRadius: "4px",
                  }}
                ></div>
                <span style={{ fontSize: "11px", color: "#666" }}>{item.national}</span>
              </div>
            </div>
          ))}
        </div>
      );
    }

    // Desktop version
    return (
      <div
        style={{
          padding: "40px",
          backgroundColor: "transparent",
          fontFamily: "Arial, sans-serif",
        }}
      >
        {/* Title */}
        <h2
          style={{
            textAlign: "center",
            fontSize: "28px",
            marginBottom: "20px",
            fontWeight: "400",
          }}
        >
          Factor Averages
        </h2>

        {/* Legend */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "30px",
            marginBottom: "30px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <div
              style={{
                width: "12px",
                height: "12px",
                borderRadius: "50%",
                backgroundColor: "#7BC96F",
              }}
            ></div>
            <span style={{ fontSize: "14px" }}>Junebug</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <div
              style={{
                width: "12px",
                height: "12px",
                borderRadius: "50%",
                backgroundColor: "#999999",
              }}
            ></div>
            <span style={{ fontSize: "14px" }}>National</span>
          </div>
        </div>

        {/* Chart */}
        <svg
          width={chartLeftMargin + chartWidth + 100}
          height={chartData.length * barSpacing + 80}
          style={{ display: "block", margin: "0 auto" }}
        >
          {/* Grid lines */}
          {[0, 1, 2, 3, 4].map((tick) => (
            <g key={`grid-${tick}`}>
              <line
                x1={chartLeftMargin + (tick / maxValue) * chartWidth}
                y1={20}
                x2={chartLeftMargin + (tick / maxValue) * chartWidth}
                y2={chartData.length * barSpacing + 20}
                stroke="#e0e0e0"
                strokeWidth="1"
              />
              <text
                x={chartLeftMargin + (tick / maxValue) * chartWidth}
                y={chartData.length * barSpacing + 40}
                textAnchor="middle"
                fontSize="12"
                fill="#666"
              >
                {tick}
              </text>
            </g>
          ))}

          {/* Bars */}
          {chartData.map((item, index) => {
            const yPosition = index * barSpacing + 20;
            const yPositionJune = index * barSpacing;
            const nationalWidth = (item.national / maxValue) * chartWidth;
            const junebugWidth = (item.junebug / maxValue) * chartWidth;

            return (
              <g key={item.id}>
                {/* Label */}
                <text
                  x={chartLeftMargin - 10}
                  y={yPosition + barHeight / 2 + 5}
                  textAnchor="end"
                  fontSize="14"
                  fill="#333"
                >
                  {item.label}
                </text>

                {/* National bar */}
                <rect
                  x={chartLeftMargin}
                  y={yPosition}
                  width={nationalWidth}
                  height={barHeight}
                  fill="#999999"
                  rx="5"
                  onMouseEnter={() =>
                    setHoveredBar({ type: "national", ...item, index })
                  }
                  onMouseLeave={() => setHoveredBar(null)}
                  style={{ cursor: "pointer" }}
                />

                <rect
                  x={chartLeftMargin}
                  y={yPositionJune}
                  width={junebugWidth}
                  height={barHeight}
                  fill="#7BC96F"
                  rx="5"
                  onMouseEnter={() =>
                    setHoveredBar({ type: "Junebug", ...item, index })
                  }
                  onMouseLeave={() => setHoveredBar(null)}
                  style={{ cursor: "pointer" }}
                />

                {/* Tooltip */}
                {hoveredBar && hoveredBar.index === index && (
                  <g>
                    <rect
                      x={chartLeftMargin + nationalWidth + 10}
                      y={yPosition - 20}
                      width={280}
                      height={80}
                      fill="#333333"
                      rx="5"
                    />
                    <text
                      x={chartLeftMargin + nationalWidth + 20}
                      y={yPosition}
                      fill="white"
                      fontSize="14"
                      fontWeight="bold"
                    >
                      {item.label}
                    </text>
                    <text
                      x={chartLeftMargin + nationalWidth + 20}
                      y={yPosition + 25}
                      fill="white"
                      fontSize="13"
                    >
                      National: {item.national}
                    </text>
                  </g>
                )}
              </g>
            );
          })}
        </svg>
      </div>
    );
  };

  const download = () => {
    fetch(manual).then((response) => {
      response.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = "S-CCATEManual.pdf";
        alink.click();
      });
    });
  };

  // Inline styles for the banner and fade animation
  const bannerStyles = {
    banner: {
      position: 'fixed',
      top: '55px', // Matches navbar height exactly
      left: 0,
      right: 0,
      backgroundColor: '#dc3545',
      color: 'white',
      display: 'flex',
      flexDirection: mobileView ? 'column' : 'row',
      justifyContent: 'center',
      alignItems: 'center',
      gap: mobileView ? '10px' : '20px',
      padding: mobileView ? '10px 15px' : '12px 20px',
      zIndex: 999,
      boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
    },
    bannerText: {
      fontSize: mobileView ? '14px' : '16px',
      fontWeight: '600',
      margin: 0,
      textAlign: 'center'
    },
    bannerButton: {
      backgroundColor: 'white',
      color: '#dc3545',
      border: 'none',
      padding: mobileView ? '6px 16px' : '8px 20px',
      borderRadius: '25px',
      fontWeight: '600',
      cursor: 'pointer',
      textDecoration: 'none',
      fontSize: mobileView ? '13px' : '14px'
    },
    bannerSpacer: {
      height: mobileView ? '70px' : '50px' // More space for stacked mobile banner
    }
  };

  // Smooth scroll handler for internal anchor links
  const handleSmoothScroll = (e, targetId) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div>
      {/* CSS for fade-in animation and smooth scrolling */}
      <style>{`
        html {
          scroll-behavior: smooth;
        }
        .fade-in-section {
          opacity: 0;
          transform: translateY(30px);
          transition: opacity 0.6s ease-out, transform 0.6s ease-out;
        }
        .fade-in-visible {
          opacity: 1;
          transform: translateY(0);
        }
      `}</style>

      {/* Fixed Red Banner for Validation Survey */}
      <div style={bannerStyles.banner}>
        <span style={bannerStyles.bannerText}>Take National Validation Survey</span>
        <Link
          to="/ValidationSurvey"
          style={bannerStyles.bannerButton}
        >
          Take Survey
        </Link>
      </div>
      {/* Spacer to prevent content from being hidden behind fixed banner */}
      <div style={bannerStyles.bannerSpacer}></div>
      {/*
      <div className="validation-background" style={{ width: "100%" }}>
  <div className="container-flex" style={{
    display: "flex",
    alignItems: "stretch",
    minHeight: "300px"
  }}>
    <div className="image-container" style={{
      flex: 1,
      position: "relative",
      overflow: "hidden"
    }}>
      <img
        src={taking_survey}
        alt="Survey"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          clipPath: "ellipse(100% 100% at 0% 50%)"
        }}
      />
    </div>
    <div className="content-container" style={{
      flex: 1,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "40px",
      backgroundColor: "#your-background-color"
    }}>
      <b style={{
        color: "white",
        fontSize: "24px",
        marginBottom: "20px",
        textAlign: "center"
      }}>
        Take Part in Validation Survey
      </b>
      <a
        href="/ValidationSurvey"
        className="survey-button"
        style={{
          backgroundColor: "white",
          color: "red",
          padding: "10px 20px",
          textDecoration: "none",
          borderRadius: "5px",
          display: "inline-block",
          fontWeight: 600,
          transition: "transform 0.2s"
        }}
        onMouseEnter={(e) => e.target.style.transform = "scale(1.05)"}
        onMouseLeave={(e) => e.target.style.transform = "scale(1)"}
      >
        Access Survey
      </a>
    </div>
  </div>
</div>*/}
      <div className="welcome">
        {/*
      Alert Message to access validation survey
      */}

        <div className="welcome-left">
          <img src={logo} className="welcome-logo" />
        </div>
        <div className="welcome-title">
          <h3>
            School Compassionate Culture Analytical Tool for Educators (S-CCATE) and Companion Student Survey
          </h3>
        </div>
        <div className="welcome-sub">
          <h4>Developed by the Center for Educational Improvement</h4>
        </div>
        <div className="container-flex">
          <div>
            <div className="welcome-message welcome-left">
              S-CCATE assessments are uniquely designed for schools to guide
              teams of educators and whole school communities through the
              process of compassionate transformational change.
            </div>
            <div className="">
              <a href="#learn-more" style={{ textDecoration: 'none' }} onClick={(e) => handleSmoothScroll(e, 'learn-more')}>
                <div className="welcome-button" style={{ cursor: 'pointer', color: 'white' }}>
                  LEARN MORE
                </div>
              </a>
              <a href="#pricing-welcome" style={{ textDecoration: 'none' }} onClick={(e) => handleSmoothScroll(e, 'pricing-welcome')}>
                <div className="welcome-button" style={{ cursor: 'pointer', color: 'white' }}>
                  VIEW PRICING
                </div>
              </a>
            </div>
          </div>
          <img src={teacher_with_students} className="welcome-img" />
        </div>

        {/*<div className="page-break small-spacer"></div>*/}

        <div className="container-flex small-spacer fade-in-section" id="validation-study" ref={addToFadeRefs}>
          <div className="welcome-left">
            <div className="info-title">
              <h3>2025-2026 National Validation Study</h3>
            </div>
            <div className="welcome-info">
              <p>
                We are requesting your help in completing the 2025-2026 S-CCATE
                National Validation Study. This study will be conducted from
                December 2025- February 2026 to help us validate the 2026
                version of S-CCATE, as revised to reflect the needs of educators
                and students in the US during the current time when many changes
                are occurring in schools across America. We anticipate it
                will take 10-12 minutes to complete.
                <br />
                <br />
                If 7 or more educators at your school complete the survey{" "}
                <b>
                  we will provide you with an S-CCATE report,{" "}
                  <u>at no charge.</u>
                </b>{" "}
                That report will include your school's ratings for each of the 5
                domains, and a graphical comparison of your data to the national
                S-CCATE database, with recommendations for follow-up to improve
                your school culture and climate.
              </p>
            </div>
          </div>
          <img src={megaphone} className="welcome-img" />
        </div>
        <div className="welcome-info welcome-left">
          <p>
            Schools participating in the validation study with 7+ respondents will receive S-CCATE and S-CCATE Student Voice Survey graphical results with a comparison to national data.
Participating schools will also be eligible to receive S-CCATE and the S-CCATE Pro Package at a 50% discount, along with a free TeachLink membership, available beginning in May 2026.
          </p>
          <p>
            Participants will not only have the option to receive their
            school report, but they will be emailed a copy of the S-CCATE
            Validation Findings, anticipated to be available by April 2026.
            Moreover, if you administer the S-CCATE Student Voice Survey to
            students, we will provide those results as well. If you are a part
            of our Validation Study, subscribe to our S-CCATE program to receive
            full S-CCATE reports and Action Guides at discounted rates.
          </p>
          <i>
          <p style={{ color:"red" }}>National Validation Participants: No need to register.</p>
          <p>Registered accounts are for S-CCATE users who have purchased one of the S-CCATE plans.</p></i>
          {/*
          <p>
            <i>
              There are two ways to participate in the National Validation Study.
              Choose an option below to get started.
            </i>
          </p>*/}
        </div>{/*
        <div className="container-flex" id="registration" style={{ justifyContent: 'center' }}>
          <Link to={{ pathname: "/Register", state: { defaultRole: "admin" } }} style={{ textDecoration: 'none' }}>
            <div className="welcome-button left-button" style={{ cursor: 'pointer', color: 'white' }}>
              REGISTER AS A SCHOOL
            </div>
          </Link>
          <Link to={{ pathname: "/Register", state: { defaultRole: "teacher" } }} style={{ textDecoration: 'none' }}>
            <div className="welcome-button right-button" style={{ cursor: 'pointer', color: 'white' }}>
              REGISTER AS AN INDIVIDUAL
            </div>
          </Link>
        </div>*/}

        <div className="container-flex spacer fade-in-section" ref={addToFadeRefs}>
          <div>
            <div className="info-title welcome-left">
              <h3>
                S-CCATE: The Evidence-Based Roadmap to a Compassionate School
                Culture
              </h3>
            </div>
            <div className="welcome-info welcome-left">
              <p>
                The S-CCATE (School-Compassionate Culture Analytical Tool for
                Educators) is a validated, online assessment designed to measure
                and guide the transformation of your school environment.
                <br />
                <br />
                S-CCATE is the barometer of school compassionate cultures,
                grounded in neuroscience and understanding how emotions affect
                cognition/learning, with practical applications to strengthen
                student belonging, engagement, experience and voice while
                simultaneously cultivating the health and well-being of students
                and staff.
                <br />
                <br />
                The tool uses the Heart Centered Learning (HCL) framework – CEI's
                signature approach to social-emotional learning (SEL) and
                mindfulness – to provide an easy-to-use, efficient,
                evidence-based solution.By identifying strengths and needs,
                S-CCATE helps educators and school communities address the
                critical rise in mental health issues, stress, loneliness, and
                isolation facing students today.
              </p>
            </div>
          </div>
          {!mobileView && <img src={gears} className="welcome-img" />}
        </div>

        <div className="welcome-info spacer green">
          <p>
            <b>Sample S-CCATE Questions for Educators:</b>
          </p>
        </div>
        <div className="info-box small-spacer">
          <p>
            <i>
              "Students are taught strategies for self-regulation, stress
              management, and resilience."
              <br />
              <br />
              "Teachers and administrators further participation and a sense
              of belonging for all students."
              <br />
              <br />
              "My school's culture reflects a spirit of happiness and joy."
            </i>
          </p>
        </div>

        <div className="info-title welcome-left spacer fade-in-section" id="evidence-base" ref={addToFadeRefs}>
          <h3>Evidence-Based Rigor: Our Commitment to Validated Results</h3>
        </div>
        <div className="welcome-info welcome-left">
          <p>
            When addressing the urgent need to support student mental health and
            academic success, you need tools you can trust. The S-CCATE is built
            on a foundation of rigorous research and proven validity.
          </p>
        </div>

        <div className="container-flex">
          <div className="welcome-left welcome-info">
            <div className="container-flex welcome-info-two green" style={mobileView ? { justifyContent: 'center' } : {}}>
              <p style={mobileView ? { textAlign: 'center' } : {}}>
                <br />
                <b>Validated Science You Can Rely On</b>
              </p>
              {!mobileView && <img src={left} className="arrow" />}
            </div>
            <p>
              S-CCATE is a validated, online school culture assessment that was
              developed over six years through collaboration with a diverse
              group of experts, including educational leaders, principals,
              neuroscientists, yoga/mindfulness practitioners, and teachers.
              <br />
              <br />
              To ensure the highest quality data, we completed a comprehensive
              validation study in 2018 with 814 practicing educators. The
              results demonstrated the tool's high reliability and validity,
              confirming exceptional internal consistency. The reliability
              measurementforthe five core factors achieved a high Spearman-Brown
              score of 0.94.
            </p>
          </div>
          {!mobileView && <img src={head} />}
        </div>

        <div className="container-flex">
          {!mobileView && <img src={house} />}
          <div className="welcome-left welcome-info">
            <div className="container-flex welcome-info-two green" style={mobileView ? { justifyContent: 'center' } : {}}>
              {!mobileView && <img src={right} className="arrow" />}
              <p style={mobileView ? { textAlign: 'center' } : {}}>
                <br />
                <b>Benchmarking Against National Progress</b>
              </p>
            </div>
            <p>
              S-CCATE allows you to track your school's progress and see how
              your efforts stack up against national trends, providing meaningful
              context for transformation.
              <br />
              <br />
              After national validation, S-CCATE was used by over 1,000
              educators in New England as part of the Childhood-Trauma Learning
              Collaborative, a joint project between the Center for Educational
              Improvement and Yale University's Program for Recovery and Community
              Health.
            </p>
          </div>
        </div>

        <div className="container-flex welcome-info-two green" style={mobileView ? { justifyContent: 'center' } : {}}>
          <p style={mobileView ? { textAlign: 'center' } : {}}>
            <br />
            <b>Actionable Insights Delivered to Your District</b>
          </p>
          {!mobileView && <img src={left} className="arrow" />}
        </div>
        <div className="container-flex">
          <div className="welcome-left welcome-info">
            <p>
              After completing the S-CCATE survey, participants will receive a
              comprehensive data report compiled electronically, presented with
              an aggregated dashboard of your district's data with easy-to-read
              graphics.
              <br />
              <br />
              The results are kept confidential at the individual level, as they
              are combined with school, district, and global-level data to
              provide insight into overall needs and strengths.
              <br />
              <br />
              The report is designed to serve as a foundational tool for
              conducting a needs assessment and monitoring implementation and
              progress of compassionate practices.
            </p>
          </div>
          <img src={comp_screen} />
        </div>

        <div className="tiny small-spacer">
          <p>
            Our S-CCATE platform employs industry standard measures to protect
            your data, including end-to-end encryption, tokenization of payment
            data, multi-factor authentication to prevent unauthorized access,
            backups, password protection, and strict access controls. We ensure
            convenient, secure cloud access. We comply with all applicable laws
            and maintain industry standard security tools such as anti-virus and
            intrusion detection systems, which are updated as standards evolve.
            All staff and agents are trained in data protection, and our
            safeguards protect sensitive data.
          </p>
        </div>

        <div className="info-title welcome-left small-spacer fade-in-section" id="purpose-use" ref={addToFadeRefs}>
          <h3>Purpose and Use of S-CCATE</h3>
        </div>
        <div className="small-welcome-info welcome-left" style={{ overflow: "hidden" }}>
          {!mobileView && (
            <img
              src={example_questions}
              className="example-questions"
              style={{
                float: "right",
                marginLeft: "20px",
                marginBottom: "10px",
                maxWidth: "40%"
              }}
            />
          )}
          <p>
            Today, as we face large-scale global crises, we all are affected
            by stress and trauma, with multi-layered impacts of fears,
            inequities, injustice, trauma, and uncertainty. Adding more
            compassion to school, as evidenced by recent research on
            neurobiology, cultures can provide much needed relief to
            students,families, and educators. Compassionate practices can
            enhance self-care, well-being, learning, and resiliency. S-CCATE
            is relevant and easy to use for rating school culture with in-class
            or remote instruction. For remote learning, please consider Use the
            S-CCATE for an initial assessment to guide discussion with others
            about school status, visions, planning, and implementation of
            plans for developing schools as Heart Centered Learning®
            communities. "classrooms" to also mean "virtual classrooms" and
            instruction and communities to refer to "virtual instruction and
            virtual communities".
          </p>
          {mobileView && (
            <img
              src={example_questions}
              className="example-questions"
              style={{
                display: "block",
                margin: "15px auto",
                maxWidth: "100%"
              }}
            />
          )}
        </div>
        <div className="welcome-left small-welcome-info">
          <p>
            The S-CCATE was notably utilized in the{" "}
            <b>
              <u>Compassionate School Leadership Academy (CSLA),</u>
            </b>{" "}
            a national research project funded by the U.S.Department of Education
            to train educators on Compassionate School Practices and prepare
            leaders to create inclusive learning environments.
            <br />
            <br />
            Use the S-CCATE for an initial assessment to guide discussion with
            others about school status, visions, planning, and implementation of
            plans for developing schools as Heart Centered Learning®
            communities.
          </p>
        </div>
        <div className="alt-info-title welcome-left small-spacer">
          <h3>
            <b>Use Cases</b>
          </h3>
        </div>

        <div className="container-flex">
          <div className="margin-left">
            <img src={bullet_one} className="bullet" />
          </div>
          <div className="welcome-info">
            <p>Interpret Results of SEL Programs</p>
          </div>
        </div>
        <div className="container-flex">
          <div className="margin-left">
            <img src={bullet_two} className="bullet" />
          </div>
          <div className="welcome-info">
            <p>Identify Strengths and Needs</p>
          </div>
        </div>
        <div className="container-flex">
          <div className="margin-left">
            <img src={bullet_three} className="bullet" />
          </div>
          <div className="welcome-info">
            <p>Plan PD (i.e., training and reviews) and Interventions</p>
          </div>
        </div>
        <div className="container-flex">
          <div className="margin-left">
            <img src={bullet_four} className="bullet" />
          </div>
          <div className="welcome-info">
            <p>Assess Non-Academic ESSA-Aligned Factors</p>
          </div>
        </div>
        <div className="container-flex">
          <div className="margin-left">
            <img src={bullet_five} className="bullet" />
          </div>
          <div className="welcome-info">
            <p>Assess Response to Trauma-Impacted Youth</p>
          </div>
        </div>
        <div className="container-flex">
          <div className="margin-left">
            <img src={bullet_fivedotfive} className="bullet" />
          </div>
          <div className="welcome-info">
            <p>Access Evidence-Based Mental Health Practice Recommendations</p>
          </div>
        </div>
        <div className="container-flex">
          <div className="margin-left">
            <img src={bullet_six} className="bullet" />
          </div>
          <div className="welcome-info">
            <p>Access Free Training and Technical Assistance</p>
          </div>
        </div>
        <div className="container-flex">
          <div className="margin-left">
            <img src={bullet_seven} className="bullet" />
          </div>
          <div className="welcome-info">
            <p>CEI Collaborations Planning, PD, and Implementation</p>
          </div>
        </div>
        <div className="container-flex">
          <div className="margin-left">
            <img src={bullet_eight} className="bullet" />
          </div>
          <div className="welcome-info">
            <p>Use CEI's Books Series to Guide You</p>
          </div>
        </div>
        <div className="container-flex">
          <div className="margin-left">
            <img src={bullet_nine} className="bullet" />
          </div>
          <div className="welcome-info">
            <p>Accessible data regarding student needs within the district</p>
          </div>
        </div>

        <div className="container-flex welcome-left">
          <div className="flex small-spacer welcome-info">
            {!mobileView && <img src={cartoon_computer} className="small-img" />}
            <h3 className="blue-title">
              <b>Benefits</b>
            </h3>
            <p>Initially used with over 2,000 educators</p>
            <ul>
              <li>
                <b>Identifies Individual Strengths & Needs:</b> Every school
                receives a report identifying their areas of strength and where
                they can improve.
              </li>
              <li>
                <b>Provides Recommendations:</b> Includes recommendations that
                can be used for planning, decision making, and professional
                development.
              </li>
              <li>
                <b>Comparison to National and District Averages:</b> See your
                schools' strength and growth areas compared to our growing
                database of responses from around the nation.
              </li>
              <li>
                <b>Quick & Easy:</b> Survey can be completed in just 12-15
                minutes.
              </li>
              <li>
                <b>Aligned with ESSA:</b> Alignment with ESSA (Every Student
                Succeeds Act) non-academic factors for easy reporting.
              </li>
              <li>
                <b>Holistic Measure:</b> Provides a complete picture of SEL and
                school culture.
              </li>
              <li>
                <b>Companion Student Survey:</b> The S-CCATE Student Survey
                provides a snapshot of students' perspectives to aid in
                decision-making
              </li>
            </ul>
          </div>
        </div>

        <div className="info-title welcome-left small-spacer fade-in-section" id="data-section" ref={addToFadeRefs}>
          <h3>Data Available from S-CCATE</h3>
        </div>
        <div className="welcome-info welcome-left">
          <p>
            Use Schools, districts, or core learning teams can use S-CCATE to
            identify strengths and areas for professional development,
            intervention, and improvement.
          </p>
        </div>
        <div className="container-flex welcome-info center-div">
          <div className="yellow-border">
            <p>
              <b>School Factor Ratings</b>
            </p>
          </div>
          <div className="yellow-border">
            <p>
              <b>Comparison to Nationally Normed Sample</b>
            </p>
          </div>
          <div className="yellow-border">
            <p>
              <b>Possible Comparison to District</b>
            </p>
          </div>
        </div>

        <div className="info-title welcome-left small-spacer">
          <h3>Benchmarking Mock-Up</h3>
        </div>
        <div className="welcome-info welcome-left">
          <p>
            Use the national benchmarking to track your school's progress,
            identify strengths and needs, and provide context for
            transformation.
          </p>
        </div>
        <div>
          {/* Your other Welcome component content */}

          {/* Insert the chart wherever you want */}
          {renderFactorChart()}

          {/* More content */}
        </div>

        <div className="info-title welcome-left fade-in-section" id="learn-more" ref={addToFadeRefs}>
          <h3>Inside the S-CCATE Framework</h3>
        </div>
        <div className="welcome-info welcome-left">
          <p>
            S-CCATE is an assessment tool that measures school culture based on
            the Heart Centered Learning Framework and provides recommendations
            for next steps.
          </p>
        </div>

        <div className="container-flex welcome-left">
          {!mobileView && <img src={hands} className="hands-img" />}
          <div>
            <div className="welcome-info green">
              <p>
                <b>Sample S-CCATE Questions for Educators:</b>
              </p>
            </div>
            <div className="welcome-info">
              <p>
                An approach to social emotional learning and mindfulness
                developed by the Center for Educational Improvement focused on
                the 5 Cs:
              </p>
              <div className="container-flex">
                <div className="margin-info">CONSCIOUNESS</div>
                <div className="margin-info">COMPASSION</div>
                <div className="margin-info">CONFIDENCE</div>
                <div className="margin-info">COURAGE</div>
                <div className="margin-info">COMMUNITY</div>
              </div>
            </div>
          </div>
        </div>

        <div className="alt-info-title small-spacer">
          <h3>
            <b>S-CCATE Survey Measures 5 Transformational Factors</b>
          </h3>
          <img src={factors_diagram} />
        </div>

        <div className="container-flex small-spacer fade-in-section" id="implementation" ref={addToFadeRefs}>
          <div className="overflow">
            <img src={logo} className="sccate-logo" />
            <div className="info-title green welcome-left">
              <h3>Implementation</h3>
            </div>
            <div className="welcome-info welcome-left">
              <p>How does S-CCATE work?</p>
            </div>
          </div>
        </div>

        <div className="welcome-left welcome-info">
          <p>
            <b className="blue">Sign up your school or district for S-CCATE.</b>
            <br />
            You can choose whether to provide staff with the survey link via an
            anonymous link or through email.
          </p>
        </div>
        <div className="welcome-left welcome-info">
          <p>
            <b className="blue">Staff completes S-CCATE Survey.</b>
            <br />
            Staff completes 40-question online survey. The survey can be
            completed be any on-site staff including teachers, administrators,
            school psychologists, social workers, and school aides.
          </p>
        </div>

        <div className="container-flex">
          <div>
            <div className="welcome-left welcome-info">
              <p>
                <b className="blue">S-CCATE generates individualized report.</b>
                <br />
                Each school receives an individualized report of the aggregated
                results of with their strengths and areas of need. Results can
                be compared with national averages and within districts/states
              </p>
            </div>
            <div className="welcome-left welcome-info">
              <p>
                <b className="blue">Implement report recommendations.</b>
                <br />
                Reports include specific recommendations to improve in your
                school. These recommendations can help you make decisions about
                what to focus on, as well as for professional development and
                teacher planning.
              </p>
            </div>
          </div>
          <img src={teacher_paperwork} className="teacher-paperwork" />
        </div>

        <div className="welcome-left welcome-info">
          <p>
            <b className="blue">Repeat up to 3 Times Per Year.</b>
            <br />
            S-CCATE can be administered up to 3x per year so schools can track
            their progress and tailor their approaches accordingly.
          </p>
        </div>

        <div className="info-title welcome-left spacer fade-in-section" ref={addToFadeRefs}>
          <h3>What Our Leaders Are Saying</h3>
        </div>

        <div className="welcome-info">
          <img src={quote_open} />
          <p>
            "S-CCATE helped our administrators identify our strengths <br />
            and also where we needed to focus to improve our school culture. It
            is
            <br />
            an empowering tool." <br />— <i>Joan Cavallo, Principal</i>
            <br />
            <br />
            "We found that the S-CCATE tool helped us identify factors that may
            be <br />
            influencing our school culture and community, providing our team
            with <br />
            information to explore and consider for inclusion in our strategic
            plans."
            <br />— <i>Dr. Rachel Santa, Director of Special Services</i>
          </p>
          <img src={quote_close} />
        </div>
        <div className="large-text">
          <p>
            <i>Real Results. Real Impact.</i>
          </p>
        </div>

        <div className="info-title welcome-left small-spacer fade-in-section" id="student-voice" ref={addToFadeRefs}>
          <h3>
            Deepening Your Understanding
            <br />
            of Student Needs - <i>Student Survey Supplement</i>
          </h3>
        </div>
        <div className="welcome-info welcome-left">
          <p>
            To complement the essential data gathered from educators, our
            Student Voice Survey provides a necessary pathway to hear directly
            from those at the heart of the learning environment – your students.
            The S-CCATE Student Voice Survey aligns closely with adult
            perceptions of what students need and experience.
            <br /> <br />
            While educators assess their perceptions of student and school wide
            strengths and needs, this additional survey, designed for students
            in grades 4-12, captures the students' direct experience regarding
            factors that improve well-being, executive functioning, and
            neuroplasticity.
          </p>
        </div>

        <div className="container-flex">
          <div className="welcome-info welcome-left">
            <p>
              <i>Hearing the student voice allows schools to:</i>
              <br />
              <br />
              <b>Measure Belonging and Safety</b> - Understand if students truly
              feel a sense of belonging (connectedness to the larger school
              community) and security in their classrooms.
              <br />
              <br />
              <b>Assess Impact of Stress and Trauma</b> - Provide direct insight
              into student perceptions of stress and emotional self-regulation,
              which helps students gain resiliency and overcome barriers to
              learning.
              <br />
              <br />
              <b>Gauge Transformational Change</b> - Directly measure the impact
              of Heart Centered Learning practices, such as how often students
              experience compassion, confidence, and courage.
            </p>
          </div>
          <img src={students_studying} className="teacher-paperwork" />
        </div>

        <div className="welcome-info small-spacer small-width">
          <table className="comparison-table">
            <thead>
              <tr>
                <th>Core Focus (Based on 5 Cs)</th>
                <th>Student-Facing Inquiry (Sample Language)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Conscious Awareness of Emotions</td>
                <td>
                  "My school provides relaxation and mindfulness activities"
                </td>
              </tr>
              <tr>
                <td>Leadership & Community</td>
                <td>"Our school welcomes and supports student leadership."</td>
              </tr>
              <tr>
                <td>Confidence & Self-Esteem</td>
                <td>"I feel okay speaking up and asking for help."</td>
              </tr>
              <tr>
                <td>Courage & Resilience</td>
                <td>
                  "When I make a mistake, I feel encouraged to learn from it and
                  try again."
                </td>
              </tr>
              <tr>
                <td>Culture of Belonging</td>
                <td>
                  "I feel a sense of belonging, safety, and connectedness when
                  at school."
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="info-title welcome-left spacer fade-in-section" id="pricing-welcome" ref={addToFadeRefs}>
          <h3>Pricing</h3>
        </div>
        <div className="welcome-info welcome-left">
          <p>
            Please contact <b>cei@edimprovement.org</b> to order your Basic,
            Pro, or Pro Plus package. We also encourage you to inquire about our{" "}
            <b>custom yearly and multi-year support</b> packages tailored to
            suit the needs of your research project, professional development,
            or school initiative. The Parties agree to an initial base price{" "}
            <b>per year, per customer group</b> as follows:
          </p>
        </div>

        <div className="container-flex align-top small-spacer fade-in-section" ref={addToFadeRefs}>
          <div>
            <div className="white-title green-background black-border">
              <p>Basic</p>
            </div>
            <div className="black-border">
              <p>
                $1,050-$3,750/yr <br />
                <br />
                7-49 respondents ($1,050)
                <br />
                50-99 respondents ($2,500)
                <br />
                100-199 respondents ($3,750)
                <br />
                Basic Report with Charts
                <br />
                National Average Comparison
                <br />
                Strengths and Needs
                <br />
                Basic Recommendations
                <br />
                Monthly eNewsletter
              </p>
            </div>
          </div>
          <div>
            <div className="white-title dark-green-background black-border">
              <p>Pro</p>
            </div>
            <div className="black-border">
              <p>
                Basic + $600/yr <br />
                <br />
                7-49 respondents ($1,650)
                <br />
                50-99 respondents ($3,100)
                <br />
                100-199 respondents ($4,350)
                <br />
                Basic Report with Charts
                <br />
                National Average Comparison
                <br />
                Strengths and Needs
                <br />
                Basic Recommendations
                <br />
                Monthly eNewsletter
                <br />
                Round One Action Guide
              </p>
            </div>
          </div>
          <div>
            <div className="white-title darker-green-background black-border">
              <p>Pro Plus</p>
            </div>
            <div className="black-border">
              <p>
                Basic + $1,200/yr <br />
                <br />
                7-49 respondents ($2,250)
                <br />
                50-99 respondents ($3,700)
                <br />
                100-199 respondents ($4,950)
                <br />
                Basic Report with Charts
                <br />
                National Average Comparison
                <br />
                Strengths and Needs
                <br />
                Basic Recommendations
                <br />
                Monthly eNewsletter
                <br />
                Round One Action Guide
                <br />
                Round Two and Three Action
                <br />
                Guides
              </p>
            </div>
          </div>
        </div>

        <div className="info-title welcome-left small-spacer fade-in-section" id="letter-section" ref={addToFadeRefs}>
          <h3>Letter to the Educators</h3>
        </div>
        <div className="welcome-info welcome-left">
          <p>
            Key advantages of S-CCATE in comparison to other school climate or
            culture tools are:
          </p>

          <ul>
            <li>
              <p>
                It is an evidenced-based approach initially validated with a
                sample of over 800 educators, across Pre-K-12 grades.
              </p>
            </li>
            <li>
              <p>
                S-CCATE is a quick survey designed to be completed online in
                10-12 minutes by educators.
              </p>
            </li>
            <li>
              <p>
                Powered by TeachLink, S-CCATE data are maintained on a secure
                platform.
              </p>
            </li>
            <li>
              <p>
                It complements CASEL's SEL Core Competencies. Here is the Heart
                Centered Learning CASEL Crosswalk comparison.
              </p>
            </li>
            <li>
              <p>
                With S-CCATE Basic you will receive data, graphic and tabular
                summaries, and recommendations to address your school or
                district's needs.
              </p>
            </li>
            <li>
              <p>
                We provide comparative data – comparing your school/district's
                data to other schools in your district and to our national
                sample.
              </p>
            </li>
            <li>
              <p>
                S-CCATE Basic gives you up to three (beginning of year, interim,
                and end of the year) reports annually.
              </p>
            </li>
            <li>
              <p>
                With S-CCATE Basic, you will also receive our monthly
                eNewsletter containing research and practical advice on
                improving school culture.
              </p>
            </li>
            <li>
              <p>
                Options to also purchase the S-CCATE Action Guides and service
                packages with further discounts.
              </p>
            </li>
            <li>
              <p>
                Our team's availability to provide consultation and facilitation
                at your school/district and online.
              </p>
            </li>
          </ul>
        </div>
        <div className="welcome-info welcome-left">
          <p>
            Today, schools are bombarded with stress as educators struggle to
            raise student achievement and address the many, multi-layered
            impacts of violence, injustice, and trauma faced by so many. We
            believe, and significant research supports our belief, that adding
            more compassion to schools can provide much needed relief to
            students, families, and educators, freeing minds for academic
            learning. Supporting research can be found in our recent
            publications; we see a consistent flow of related research, all
            suggesting that schools can be a crucial component in supporting the
            well-being of children, youth, and adults.
            <br />
            <br />
            We thank you for considering S-CCATE. To receive results for your
            school or district, at least 7 of your staff must have responded to
            S-CCATE.
          </p>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: mobileView ? "column" : "row",
            justifyContent: "space-between",
            alignItems: mobileView ? "center" : "center",
            padding: mobileView ? "15px 10px" : "20px",
            gap: mobileView ? "15px" : "0",
          }}
        >
          {/* Left div - image */}
          <div style={{ width: mobileView ? "auto" : "80px", height: "fit-content" }}>
            <img
              src={mason_photo}
              alt="Profile"
              style={{ width: mobileView ? "80px" : "100px", height: "auto", display: "block" }}
            />
          </div>

          {/* Center div - contains image on top and text below (not flexed) */}
          <div style={{ textAlign: mobileView ? "center" : "left", marginLeft: mobileView ? "0" : "20px", flex: mobileView ? "none" : 1 }}>
            <div>
              <img
                src={mason_signature}
                alt="Signature"
                style={{ height: mobileView ? "30px" : "40px" }}
              />
            </div>
            <div>
              <p style={{ margin: "10px 0 0 0", fontWeight: "bold", fontSize: mobileView ? "14px" : "16px" }}>
                Dr. Christine Mason, PhD
              </p>
              <p style={{ margin: "5px 0", textDecoration: "underline", fontSize: mobileView ? "13px" : "16px" }}>
                Center for Educational Improvement
              </p>
              <p style={{ margin: "5px 0 0 0", fontSize: mobileView ? "13px" : "16px" }}>
                chrismason@edimprovement.org
              </p>
            </div>
          </div>

          {/* Right div - image (aligned to right) */}
          <div>
            <img
              src={cei_graphic}
              alt="Logo"
              style={{ width: mobileView ? "80px" : "120px", height: mobileView ? "80px" : "120px" }}
            />
          </div>
        </div>

        <div className="info-title welcome-left small-spacer fade-in-section" id="value-section" ref={addToFadeRefs}>
          <h3>Value</h3>
        </div>
        <div className="welcome-info welcome-left">
          <p>S-CCATE</p>
          <ul className="welcome-info">
            <li>
              <p>
                Provides educators with data for items that are based on
                substantial research on the impact of trauma and stress; the
                importance of compassionate communities and nurturing adults;
                and the positive impact of mindfulness.
              </p>
            </li>
            <li>
              <p>
                Is based on over six years of focus groups and input from school
                leaders and pilot implementation at three sites. From that
                basis, it was used in conjunction with Yale University's Program
                for Recovery and Community Health in two projects designed to
                improve students' mental health and student and educator
                well-being.
              </p>
            </li>
            <li>
              <p>
                Provides baseline information with easy-to-interpret indicators
                for areas for intervention.
              </p>
            </li>
            <li>
              <p>
                Renders a unique assessment of educators' perception of their
                personal knowledge and skills and their perception of student
                and schoolwide strengths and needs.
              </p>
            </li>
            <li>
              <p>
                Includes factors related to trauma, neuroscience, cultural
                competence, equity, mindfulness, and school policies.
              </p>
            </li>
            <li>
              <p>
                Supports "teacher leadership" to guide teachers in making
                decisions about professional development activities and
                interventions to support compassionate school cultures.
              </p>
            </li>
            <li>
              <p>
                Sets the stage for each school to facilitate sustainable
                transformational change from within; focusing on what is most
                important to its individual school community; and cultivating
                compassionate communities where all students and educators
                thrive and flourish.
              </p>
            </li>
          </ul>
        </div>

        <div className="welcome-info welcome-left">
          <p>
            <b>For School Administrators/Points of Contact</b>
            <br />
            As school administrators, you will be primary contacts for S-CCATE
            and will have access to a variety of tools for different views and
            comparisons, including comparison with other schools in your state,
            district, or nationally. However, individual responses will be held
            in confidence. S-CCATE can be made easily available to your staff.
            To get started, contact us at TEACHLINK to receive a unique "school
            identifer" which your staff and students can use to complete S-CCATE
            and the student survey. View S-CCATE products and pricing for
            additional information.
            <br />
            <br />
            <b>For District Wide Administration of S-CCATE</b>
            <br />
            District wide administration of S-CCATE will not only provide cost
            savings, but will also provide the ability to compare data across
            schools and how they compare to the district average. Contact
            cei@edimprovement.org for information on our sliding scale and cost
            savings and discounts for districts. Contact TEACHLINK for your
            district identifer and instructions for aggregating data by schools.
            <br />
            <br />
            <b>Once you have completed S-CCATE</b>
          </p>
          <ul>
            <li>
              <p>
                You can gain access to Basic S-CCATE reports, including graphs
                and comparative national data, with identification of areas of
                strength, and recommendations for areas of needs, by completing
                an order. If you are participating as part of our CSLA program,
                we will contact you with your results. Optional services are
                also available to assist you and your school/district in
                addressing your needs and helping to develop more compassionate
                school environments. Check out our S-CCATE Suite of Services and
                S-CCATE Manual for more information.
              </p>
            </li>
          </ul>
        </div>

        <div className="info-title welcome-left small-spacer fade-in-section" id="partners" ref={addToFadeRefs}>
          <h3>Our Partners</h3>
        </div>
        <div>
          {/* First outer div - 4 images flexed */}
          <div style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: mobileView ? "center" : "center",
            gap: mobileView ? "15px" : "20px",
            marginBottom: "20px"
          }}>
            <div style={{ display: "flex", alignItems: "center", width: mobileView ? "45%" : "auto", justifyContent: "center" }}>
              <img src={sponsor_one} alt="" style={{ maxWidth: "100%", height: "auto" }} />
            </div>
            <div style={{ display: "flex", alignItems: "center", width: mobileView ? "45%" : "auto", justifyContent: "center" }}>
              <img src={sponsor_two} alt="" style={{ maxWidth: "100%", height: "auto" }} />
            </div>
            <div style={{ display: "flex", alignItems: "center", width: mobileView ? "45%" : "auto", justifyContent: "center" }}>
              <img src={sponsor_three} alt="" style={{ maxWidth: "100%", height: "auto" }} />
            </div>
            <div style={{ display: "flex", alignItems: "center", width: mobileView ? "45%" : "auto", justifyContent: "center" }}>
              <img src={sponsor_four} alt="" style={{ maxWidth: "100%", height: "auto" }} />
            </div>
          </div>

          {/* Second outer div - 3 images flexed */}
          <div style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: mobileView ? "center" : "center",
            gap: mobileView ? "15px" : "20px"
          }}>
            <div style={{ display: "flex", alignItems: "center", width: mobileView ? "45%" : "auto", justifyContent: "center" }}>
              <img src={sponsor_five} alt="" style={{ maxWidth: "100%", height: "auto" }} />
            </div>
            <div style={{ display: "flex", alignItems: "center", width: mobileView ? "45%" : "auto", justifyContent: "center" }}>
              <img src={sponsor_six} alt="" style={{ maxWidth: "100%", height: "auto" }} />
            </div>
            <div style={{ display: "flex", alignItems: "center", width: mobileView ? "45%" : "auto", justifyContent: "center" }}>
              <img src={sponsor_seven} alt="" style={{ maxWidth: "100%", height: "auto" }} />
            </div>
            <div style={{ display: "flex", alignItems: "center", width: mobileView ? "45%" : "auto", justifyContent: "center" }}>
              <img src={sponsor_eight} alt="" style={{ maxWidth: "100%", height: "auto" }} />
            </div>
          </div>
        </div>

        {/* New Pricing Section */}
        <div style={{
          padding: mobileView ? "30px 15px" : "50px 20px",
          backgroundColor: "#f5f5f5",
          marginTop: "40px"
        }}>
          <h2 style={{
            textAlign: "center",
            fontSize: mobileView ? "28px" : "36px",
            fontWeight: "bold",
            marginBottom: "5px",
            fontFamily: "Arial, sans-serif"
          }}>
            TEACHLINK PRICING TABLE
          </h2>
          <div style={{
            width: "60px",
            height: "3px",
            backgroundColor: "#000",
            margin: "0 auto 10px"
          }}></div>
          <p style={{
            textAlign: "center",
            fontSize: mobileView ? "14px" : "16px",
            letterSpacing: "2px",
            marginBottom: "30px"
          }}>
            CHOOSE YOUR BEST PLAN
          </p>

          <div style={{
            display: "flex",
            flexDirection: mobileView ? "column" : "row",
            justifyContent: "center",
            gap: "20px",
            alignItems: "stretch",
            maxWidth: "1000px",
            margin: "0 auto"
          }}>
            {/* DISCOUNTED */}
            <div style={{
              flex: 1,
              maxWidth: mobileView ? "100%" : "300px",
              backgroundColor: "#fff",
              border: "1px solid #c9a227",
              textAlign: "center",
              display: "flex",
              flexDirection: "column"
            }}>
              <div style={{
                backgroundColor: "#f5e6c8",
                padding: "15px",
                borderBottom: "1px solid #c9a227"
              }}>
                <h3 style={{ margin: 0, fontSize: "18px", letterSpacing: "1px" }}>DISCOUNTED</h3>
              </div>
              <div style={{ padding: "20px", flex: 1, display: "flex", flexDirection: "column" }}>
                <p style={{ fontSize: "48px", fontWeight: "bold", margin: "0 0 20px" }}><span style={{ fontSize: "14px", color: "#666", verticalAlign: "top", lineHeight: "48px" }}>$</span>50</p>
                <p style={{ fontSize: "14px", lineHeight: "1.6", marginBottom: "15px" }}>
                  For S-CCATE participants the rate will be discounted to $50/school year per license
                </p>
                <p style={{ fontSize: "14px", lineHeight: "1.6", marginBottom: "20px" }}>
                  Plus offering 1 FREE license for your school
                </p>
                <a href="https://docs.google.com/forms/d/e/1FAIpQLSekTkiFjHzEZFaddlZ24MxNm87gZQ647lcTWzfbEHMx073V2A/viewform?usp=publish-editor" style={{ textDecoration: "none", marginTop: "auto" }}>
                  <button style={{
                    backgroundColor: "#fff",
                    border: "2px solid #333",
                    padding: "10px 20px",
                    fontSize: "14px",
                    fontWeight: "bold",
                    cursor: "pointer"
                  }}>
                    CONTACT US
                  </button>
                </a>
              </div>
            </div>

            {/* ADVANCED */}
            <div style={{
              flex: 1,
              maxWidth: mobileView ? "100%" : "300px",
              backgroundColor: "#fff",
              border: "1px solid #2e6b8a",
              textAlign: "center",
              boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
              display: "flex",
              flexDirection: "column"
            }}>
              <div style={{
                backgroundColor: "#2e6b8a",
                padding: "15px",
                borderBottom: "1px solid #2e6b8a"
              }}>
                <h3 style={{ margin: 0, fontSize: "18px", letterSpacing: "1px", color: "#fff" }}>ADVANCED</h3>
              </div>
              <div style={{ padding: "20px", flex: 1, display: "flex", flexDirection: "column" }}>
                <p style={{ fontSize: "48px", fontWeight: "bold", margin: "0 0 20px" }}><span style={{ fontSize: "14px", color: "#666", verticalAlign: "top", lineHeight: "48px" }}>$</span>100</p>
                <p style={{ fontSize: "14px", lineHeight: "1.6", marginBottom: "15px" }}>
                  Each License is $100/academic year
                </p>
                <p style={{ fontSize: "14px", lineHeight: "1.6", marginBottom: "20px" }}>
                  Differentiated roles Administrator & Teacher
                </p>
                <a href="https://docs.google.com/forms/d/e/1FAIpQLSekTkiFjHzEZFaddlZ24MxNm87gZQ647lcTWzfbEHMx073V2A/viewform?usp=publish-editor" style={{ textDecoration: "none", marginTop: "auto" }}>
                  <button style={{
                    backgroundColor: "#2e6b8a",
                    border: "2px solid #2e6b8a",
                    color: "#fff",
                    padding: "10px 20px",
                    fontSize: "14px",
                    fontWeight: "bold",
                    cursor: "pointer"
                  }}>
                    CONTACT US
                  </button>
                </a>
              </div>
            </div>

            {/* PREMIUM SETUP */}
            <div style={{
              flex: 1,
              maxWidth: mobileView ? "100%" : "300px",
              backgroundColor: "#fff",
              border: "1px solid #c9a227",
              textAlign: "center",
              display: "flex",
              flexDirection: "column"
            }}>
              <div style={{
                backgroundColor: "#f5e6c8",
                padding: "15px",
                borderBottom: "1px solid #c9a227"
              }}>
                <h3 style={{ margin: 0, fontSize: "18px", letterSpacing: "1px" }}>PREMIUM SETUP</h3>
              </div>
              <div style={{ padding: "20px", flex: 1, display: "flex", flexDirection: "column" }}>
                <p style={{ fontSize: "48px", fontWeight: "bold", margin: "0 0 20px" }}><span style={{ fontSize: "14px", color: "#666", verticalAlign: "top", lineHeight: "48px" }}>$</span>750</p>
                <p style={{ fontSize: "14px", lineHeight: "1.6", marginBottom: "20px" }}>
                  Go beyond generic evaluation forms and timelines. Our team will help to customize your templates and forms to the needs of your education team.
                </p>
                <a href="https://docs.google.com/forms/d/e/1FAIpQLSekTkiFjHzEZFaddlZ24MxNm87gZQ647lcTWzfbEHMx073V2A/viewform?usp=publish-editor" style={{ textDecoration: "none", marginTop: "auto" }}>
                  <button style={{
                    backgroundColor: "#fff",
                    border: "2px solid #333",
                    padding: "10px 20px",
                    fontSize: "14px",
                    fontWeight: "bold",
                    cursor: "pointer"
                  }}>
                    CONTACT US
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="welcome footer-background"
        id="contact-us"
        style={{
          display: "flex",
          flexDirection: mobileView ? "column" : "row",
          justifyContent: "space-between",
          alignItems: mobileView ? "center" : "flex-start",
          padding: mobileView ? "20px 15px" : "50px",
        }}
      >
        {/* Left div - empty spacer (hidden on mobile) */}
        {!mobileView && <div style={{ width: "120px" }}></div>}

        {/* Middle div - text content (centered) */}
        <div style={{ flex: mobileView ? "none" : 1, textAlign: "center", padding: mobileView ? "0" : "0 20px" }}>
          <p style={{ fontSize: mobileView ? "14px" : "16px" }}>
            For more information, to order, or to discuss customized S-CCATE
            options for your customer group, contact the Center for Educational
            Improvement at <b>cei@edimprovement.org</b>.
            <br />
            <br />
            Copyright © 2025 Center for Educational Improvement
            <br />
            <br />
            <i>
              I am thrilled by how fully teachers are embracing this effort and
              also by the impact on student self-regulation and positive changes
              in discipline at Lee. (Kate Retzel, School Principal)
            </i>
          </p>
        </div>

        {/* Right div - image aligned to top */}
        <div style={{ width: mobileView ? "auto" : "120px", alignSelf: mobileView ? "center" : "flex-start", marginTop: mobileView ? "15px" : "0" }}>
          <img src={cei_graphic_green} alt="" style={{ display: "block", width: mobileView ? "80px" : "auto" }} />
        </div>
      </div>
    </div>
  );
}

{
  /*{
            mobileView ? (
              <div className="welcome-center">
                <div className="welcome-title" style={{ marginBottom: "0px", fontSize: "18px" }}>
                  <h3>User Survey Instructions</h3>
                </div>
                <div className='wrap'>
                  <iframe className="frame" width="568" height="315" src="https://www.youtube.com/embed/AUG__kMdZKc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
                <div className="welcome-title" style={{ marginBottom: "0px", fontSize: "18px" }}>
                  <h3>Administrator School Sign Up Instructions</h3>
                </div>
                <div className='wrap'>
                  <iframe className="frame" width="568" height="315" src="https://www.youtube.com/embed/AUG__kMdZKc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>
            ) : (
              <div className="welcome-row">
                <div className="welcome-column">
                  <div
                    className="welcome-title "
                    style={{ marginBottom: "0px", fontSize: "18px" }}
                  >
                    <h3>User Survey Instructions</h3>
                  </div>
                  <iframe
                    width="90%"
                    height="300"
                    src="https://www.youtube.com/embed/AUG__kMdZKc"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  />
                </div>
                <div className="welcome-column">
                  <div
                    className="welcome-title"
                    style={{ marginBottom: "0px", fontSize: "18px" }}
                  >
                    <h3>School Sign Up Instructions</h3>
                  </div>
                  <iframe
                    width="90%"
                    height="300"
                    src="https://www.youtube.com/embed/iZ-oGi9SG3k"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  />
                </div>
              </div>
            )
          }
          <br />
          <br />
          <div className="welcome-column">
            <p>If your school has purchased S-CCATE</p>
            {!props.isAuthed ? (
              <a href="/Login">
                <Button
                  variant="contained"
                  color="primary"
                  className="welcome-login"
                >
                  Click Here To Login
                </Button>
              </a>
            ) : (
              <div>
                {props.userCanManage ? (
                  <div>
                    <Link to="/Reports">
                      <Button
                        variant="contained"
                        className="welcome-manage-link"
                      >
                        Click here to manage S-CCATE
                      </Button>
                    </Link>
                  </div>
                ) : null}
                <Link to="/Surveys">
                  <Button
                    variant="contained"
                    color="primary"
                    className="welcome-login"
                  >
                    Click here to take the survey
                  </Button>
                </Link>
              </div>
            )}
            <p>If your school has not purchased S-CCATE</p>
            <a href="/Pricing">
              <Button
                variant="contained"
                color="secondary"
                className="welcome-login"
              >
                {props.isAuthed ? "View Pricing Info" : "Get Started For Free"}
              </Button>
            </a>
          </div>
          <br />
          <br />
          <p style={{ fontSize: 18 }}>
            <h3>User Survey Instructions</h3>
          </p>
          <div className="welcome-center">
            <img
              src={sampleQuestions}
              style={{ maxWidth: "50%", border: "1px solid #eee" }}
            />
          </div>
          <br />
          <br />
          <div>
            <h3 style={{ color: "#006ac5" }}>Purpose and Use of S-CCATE</h3>
          </div>
          <p>
            Use the S-CCATE for an initial assessment to guide discussion with
            others about school status, visions, planning, and implementation of
            plans for developing schools as Heart Centered Learning&reg;
            communities.
          </p>
          <div className="welcome-center">
            <img src={purpose} style={{ maxWidth: "50%" }} />
            <br />
            <img src={data} style={{ maxWidth: "50%" }} />
          </div>
          <div style={{ textAlign: "center" }}>
            <a className="btn btn-primary" onClick={download}>
              Download S-CCATE Manual
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}*/
}
